import { render } from "./PaginationContent.vue?vue&type=template&id=6c991bef"
import script from "./PaginationContent.vue?vue&type=script&lang=js"
export * from "./PaginationContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__